<header
  id="app-navbar"
  class="app-header bs-navbar flex flex-col border-b border-[#adadad] bg-[var(--navbar-bg)] text-[var(--navbar-color)]"
>
  <ng-container *ngIf="locale$ | async as locale">
    <div class="navbar-top-row flex w-full flex-wrap items-center gap-4 px-4 py-3 md:flex-nowrap md:px-6">
      <div class="flex items-center gap-4">
        <button
          class="bs-navbar-toggler bs-d-lg-none inline-flex h-10 w-10 items-center justify-center rounded-md text-2xl leading-none text-[var(--navbar-color)]"
          type="button"
          appMobileSidebarToggler
          aria-label="Toggle navigation"
        >
          &#9776;
        </button>
        <a
          class="bs-navbar-brand block h-[var(--navbar-brand-height)] w-[var(--navbar-brand-width)] shrink-0 border-b border-[#1c1f21] bg-[var(--navbar-brand-bg)] bg-center bg-no-repeat"
          [routerLink]="[defaultRoute]"
          [style.background-image]="'var(--navbar-brand-logo)'"
          [style.background-size]="'var(--navbar-brand-logo-size)'"
        ></a>
      </div>

      <ul
        class="navbar-actions bs-nav bs-navbar-nav flex flex-1 list-none flex-col items-end gap-3 text-sm font-medium md:flex-row md:items-center md:justify-end md:gap-6"
      >
        <navbar-user></navbar-user>
        <li class="nav-item flex items-center">
          <a
            class="inline-flex items-center font-semibold transition-colors duration-150 hover:text-[var(--navbar-hover-color)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--navbar-hover-color)]"
            (click)="openSupportModal()"
          >
            <i class="fa fa-life-ring navbar-action-icon"></i>
            <span class="navbar-action-label">{{'Support' | translate: locale | async}}</span>
          </a>
        </li>
        <ng-container *ngIf="!!showLanguageOptions">
          <li class="nav-item flex items-center">
            <a
              class="inline-flex items-center font-semibold transition-colors duration-150 hover:text-[var(--navbar-hover-color)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--navbar-hover-color)]"
              (click)="openLanguageSelectorModal()"
            >
              <i class="fa fa-language navbar-action-icon"></i>
              <span class="navbar-action-label">{{'Language' | translate: locale | async}}</span>
            </a>
          </li>
        </ng-container>
        <navbar-logout [locale]="locale"></navbar-logout>
      </ul>
    </div>
  </ng-container>
</header>
